<template>
    <div
        :class="[{'stripe': stripe, 'hoverFlat': hoverFlat}, `vs-table-${color}`]"
        class="vs-component vs-con-table"
    >
        <!-- header -->
        <header class="header-table vs-table--header">
            <slot name="header" />
        </header>
        <div class="con-tablex vs-table--content">
            <div
                :style="styleConTbody"
                class="vs-con-tbody vs-table--tbody "
            >
                <table
                    ref="table"
                    class="vs-table vs-table--tbody-table"
                >
                    <thead
                        ref="thead"
                        class="vs-table--thead"
                    >
                        <tr>
                            <th
                                v-if="multiple || hasExpadableData"
                                class="td-check"
                            >
                                <span
                                    v-if="multiple"
                                    class="con-td-check"
                                >
                                    <vs-checkbox
                                        :key="isCheckedLine ? 'remove' : 'check'"
                                        :checked="isCheckedMultiple"
                                        :icon="isCheckedLine ? 'remove' : 'check'"
                                        color="secondary"
                                        size="small"
                                        @input="changeCheckedMultiple"
                                    />
                                </span>
                            </th>
                            <slot name="thead" />
                        </tr>
                    </thead>
                    <slot :data="datax" />
                </table>
            </div>
            <div
                v-if="isNoData"
                class="not-data-table vs-table--not-data"
            >
                {{ noDataText }}
            </div>

            <div
                v-if="pagination"
                class="con-pagination-table vs-table--pagination"
            >
                <vs-pagination
                    v-model="currentx"
                    :description="description"
                    :description-items="descriptionItems"
                    :max-items="maxItemsx"
                    :size-array="queriedResults.length"
                    :total="searchx && !sst ? getTotalPagesSearch : getTotalPages"
                    @changeMaxItems="changeMaxItems"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:  'VxTable',
    props: {
        color: {
            default: 'primary',
            type:    String,
        },
        currentPage: {
            default: 1,
            type:    [Number, String],
        },
        data: {
            default: null,
        },
        description: {
            default: false,
            type:    Boolean,
        },
        descriptionItems: {
            default: () => [],
            type:    Array,
        },
        hoverFlat: {
            default: false,
            type:    Boolean,
        },
        maxHeight: {
            default: 'auto',
            type:    String,
        },
        maxItems: {
            default: 5,
            type:    [Number, String],
        },
        multiple: {
            default: false,
            type:    Boolean,
        },
        noDataText: {
            default: 'No data Available',
            type:    String,
        },
        notSpacer: {
            default: false,
            type:    Boolean,
        },
        onlyClickCheckbox: {
            default: false,
            type:    Boolean,
        },
        pagination: {
            default: false,
            type:    Boolean,
        },
        search: {
            default: '',
            type:    String,
        },
        searchx: {
            default: '',
            type:    String,
        },
        sst: {
            default: false,
            type:    Boolean,
        },
        stripe: {
            default: false,
            type:    Boolean,
        },
        total: {
            default: 0,
            type:    Number,
        },
        value: {},
    },
    data: () => ({
        headerWidth:      '100%',
        trs:              [],
        datax:            [],
        currentx:         1,
        maxItemsx:        5,
        hasExpadableData: false,
        currentSortKey:   null,
        currentSortType:  null,
    }),
    computed: {
        getTotalPages() {
            return Math.ceil(this.total / this.maxItemsx);
        },
        getTotalPagesSearch() {
            return Math.ceil(this.queriedResults.length / this.maxItems);
        },
        isCheckedLine() {
            const lengthx = this.data.length;
            const lengthSelected = this.value.length;

            return lengthx !== lengthSelected;
        },
        isCheckedMultiple() {
            return this.value.length > 0;
        },
        isNoData() {
            if (typeof (this.datax) === 'object') {
                return this.datax ? Object.keys(this.datax).length === 0 : false;
            }

            return this.datax ? this.datax.length === 0 : false;
        },
        queriedResults() {
            let queriedResults = this.data;

            if (this.searchx && this.search) {
                const dataBase = this.data;
                queriedResults = dataBase.filter((tr) => {
                    const values = tr[this.search].toString().toLowerCase();

                    return values.indexOf(this.searchx.toLowerCase()) !== -1;
                });
            }

            return queriedResults;
        },
        styleConTbody() {
            return {
                maxHeight: this.maxHeight,
                overflow:  this.maxHeight !== 'auto' ? 'auto' : null,
            };
        },
    },
    watch: {
        currentPage() {
            this.currentx = this.currentPage;
        },
        currentx(val) {
            this.$emit('change-page', this.currentx);
        },
        maxItems(val) {
            this.maxItemsx = val;
            this.loadData();
        },
        data() {
            this.loadData();
            this.$nextTick(() => {
                if (this.datax.length > 0) {
                    this.changeTdsWidth();
                }
            });
        },
        maxItemsx() {
            this.loadData();
        },
        searchx() {
            if (this.sst) {
                this.$emit('search', this.searchx);
            } else {
                this.loadData();
            }
        },
    },
    destroyed() {
        window.removeEventListener('resize', this.listenerChangeWidth);
    },
    mounted() {
        window.addEventListener('resize', this.listenerChangeWidth);
        this.maxItemsx = this.maxItems;
        this.loadData();
    },
    methods: {
        getItems(min, max) {
            const dataBase = this.sortItems(this.data);

            const items = [];
            dataBase.forEach((item, index) => {
                if (index >= min && index < max) {
                    items.push(item);
                }
            });

            return items;
        },
        getItemsSearch(min, max) {
            const search = this.normalize(this.searchx);

            return this.sortItems(this.data).filter(tr => this.normalize(tr[this.search]
                .toString()).indexOf(search) !== -1).filter((_, index) => (index >= min && index < max));
        },
        loadData() {
            const max = this.maxItemsx;
            const min = 0;

            if (!this.searchx || this.sst) {
                this.datax = this.pagination ? this.getItems(min, max) : this.sortItems(this.data) || [];
            } else {
                this.datax = this.pagination ? this.getItemsSearch(min, max) : this.getItemsSearch(min, max) || [];
            }
        },
        changeCheckedMultiple() {
            const lengthx = this.data.length;
            const lengthSelected = this.value.length;
            const selectedx = (lengthx - lengthSelected);

            if (selectedx === 0) {
                this.$emit('input', []);
            } else {
                this.$emit('input', this.data);
            }
        },
        normalize(string) {
            return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        },
        clicktr(tr, isTr) {
            if (this.multiple && isTr && !this.onlyClickCheckbox) {
                const val = this.value.slice(0);

                if (val.includes(tr)) {
                    val.splice(val.indexOf(tr), 1);
                } else {
                    val.push(tr);
                }

                this.$emit('input', val);
                this.$emit('selected', tr);
            } else if (isTr && !this.onlyClickCheckbox) {
                this.$emit('input', tr);
                this.$emit('selected', tr);
            }
        },
        sortItems(data) {
            const { currentSortKey, currentSortType } = this;

            const getValue = (obj, keys) => (keys && keys.indexOf('.') !== -1
                ? keys.split('.').reduce((cur, key) => cur[key], obj)
                : obj[keys]);

            /**
       * Сравнивает
       *
       * @param {String} a
       * @param {String} b
       */
            const compare = (a, b) => {
                if (getValue(a, currentSortKey) < getValue(b, currentSortKey)) return currentSortType === 'desc' ? 1 : -1;

                if (getValue(a, currentSortKey) > getValue(b, currentSortKey)) return currentSortType === 'desc' ? -1 : 1;

                return 0;
            };

            return currentSortType !== null ? [...data].sort(compare) : [...data];
        },
        dblclicktr(tr, isTr) {
            if (isTr) {
                this.$emit('dblSelection', tr);
            }
        },
        sort(key, sortType) {
            this.currentSortKey = key;
            this.currentSortType = sortType;

            if (this.sst) {
                this.$emit('sort', key, sortType);

                return;
            }

            this.loadData();
        },
        changeTdsWidth() {
            if (!this.value) return;

            const tbody = this.$refs.table.querySelector('tbody');

            // Adding condition removes querySelector none error - if tbody isnot present
            if (tbody) {
                const trvs = tbody.querySelector('.tr-values');

                if (trvs === undefined || trvs === null) return;

                const tds = trvs.querySelectorAll('.td');

                const tdsx = [];

                tds.forEach((td, index) => {
                    tdsx.push({ index, widthx: td.offsetWidth });
                });

                const { colgrouptable } = this.$refs;

                if (colgrouptable !== undefined && colgrouptable !== null) {
                    const colsTable = colgrouptable.querySelectorAll('.col');
                    colsTable.forEach((col, index) => {
                        col.setAttribute('width', tdsx[index].widthx);
                    });
                }
            }
        },
        getValues(obj) {
            /**
       * @param val
       */
            function flattenDeep(val) {
                return Object.values(val || [])
                    .reduce((acc, newValue) => ((typeof newValue === 'object')
                        ? acc.concat(flattenDeep(newValue))
                        : acc.concat(newValue)), []);
            }

            return flattenDeep(obj).filter(item => (typeof item === 'string') || (typeof item === 'number'));
        },
        changeMaxItems(index) {
            this.maxItemsx = this.descriptionItems[index];
        },
        handleCheckbox(tr) {
            if (this.multiple && this.onlyClickCheckbox) {
                const val = this.value.slice(0);

                if (val.includes(tr)) {
                    val.splice(val.indexOf(tr), 1);
                } else {
                    val.push(tr);
                }

                this.$emit('input', val);
                this.$emit('selected', tr);
            }
        },
        listenerChangeWidth() {
            this.headerWidth = `${this.$refs.table.offsetWidth}px`;
            this.changeTdsWidth();
        },
    },
};
</script>

<style scoped lang="scss">
.vs-table {
    border-collapse: collapse;
    border-spacing: 0;
    border-radius: 16px;
    overflow: hidden;
}

.vs-table--header {
    display: block;
}

.con-pagination-table {
    margin-top: 24px;
}
</style>
